import { render, staticRenderFns } from "./DeleteCustomerModal.vue?vue&type=template&id=68019fcf&scoped=true"
import script from "./DeleteCustomerModal.vue?vue&type=script&lang=js"
export * from "./DeleteCustomerModal.vue?vue&type=script&lang=js"
import style0 from "./DeleteCustomerModal.vue?vue&type=style&index=0&id=68019fcf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68019fcf",
  null
  
)

export default component.exports